"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Geolocation = void 0;
var _auth = require("@ori/auth");
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _fetching = require("@ori/fetching");
var _i18n = require("@ori/i18n");
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = require("@ori/testid-generator");
var _react = require("react");
var _constants = require("../../constants");
var _constantsGenerated = require("../../constants-generated");
var _utils = require("../../utils");
var _GeolocationDialog = require("../GeolocationDialog");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Geolocation component that fetches data needed to decide visibility of geolocatin popup. If conditions are met a dialog with information about home and foreign country is displayed.
 */
const Geolocation = ({
  enabled,
  translations
}) => {
  const {
    staticApiUrl
  } = (0, _configurationManager.useServiceUrls)(['staticApi']);
  const {
    environment,
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    isAnonymousUser,
    isUserVerified
  } = (0, _auth.useToken)();
  const {
    open,
    onClose,
    onOpen
  } = (0, _presentationHooks.useDisclose)();
  const {
    data: {
      foreignCountry,
      homeCountry,
      homeCountryUrl,
      visible
    } = {
      foreignCountry: '',
      homeCountry: '',
      homeCountryUrl: '',
      visible: false
    }
  } = (0, _fetching.useSWR)(isUserVerified ? [enabled, environment, isAnonymousUser, staticApiUrl, tenant] : null, async () => (0, _utils.getGeolocationData)({
    enabled,
    environment,
    isAnonymousUser,
    staticApiUrl,
    tenant
  }), {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });
  (0, _react.useEffect)(() => {
    if (visible) {
      onOpen();
    }
  }, [onOpen, visible]);

  // We need to fetch translations with home country tenant to get correct translations.
  const countryCode = (0, _utils.getCountryCode)() ?? 'uk';
  if (!open) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
    team: _testidGenerator.Team.Presentation,
    project: _constantsGenerated.LIBRARY_NAME,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsProvider, {
      defaultTranslationsWithNamespaces: {
        [_constants.translationsNamespace]: _constants.defaultTranslations
      }
      // eslint-disable-next-line no-console -- we want to log errors
      ,

      clientFetchConfiguration: {
        onError: console.error,
        tenant: countryCode,
        baseUrl: staticApiUrl
      },
      language: navigator.language
      // istanbul ignore next -- We do not need to test fetching of translations when translations are undefined.
      ,

      translationsWithNamespaces: translations ? {
        [_constants.translationsNamespace]: translations
      } : undefined,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
        namespace: _constants.translationsNamespace,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_GeolocationDialog.GeolocationDialog, {
          foreignCountry: foreignCountry,
          homeCountry: homeCountry,
          homeCountryUrl: homeCountryUrl,
          open: open,
          onClose: onClose
        })
      })
    })
  });
};
exports.Geolocation = Geolocation;